"use client";

import {
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Youtube,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";
import Link from "next/link";
import { BrandLogo } from "@/components/shared/brand-logo";

export function Footer() {
  return (
    <footer className="border-t bg-white dark:bg-slate-950">
      {/* MAIN FOOTER */}
      <div className="bg-slate-950 dark:bg-slate-900 text-slate-300">
        <div className="container mx-auto px-4 sm:px-6 py-14">
          <div
            className="
        grid grid-cols-1
        sm:grid-cols-2
        lg:grid-cols-7
        gap-8
      "
          >
            {/* BRAND */}
            <div>
              <div className="flex items-center gap-2 mb-4">
                <BrandLogo
                  surface="dark"
                  width={140}
                  height={20}
                  className="h-12 w-auto object-contain"
                />
              </div>

              <p className="text-sm text-slate-400">
                Trusted B2B marketplace connecting buyers and suppliers
                worldwide.
              </p>

              <div className="flex gap-3 mt-4">
                {[Facebook, Twitter, Linkedin, Instagram, Youtube].map(
                  (Icon, i) => (
                    <a
                      key={i}
                      href="#"
                      className="
                    h-9 w-9
                    rounded-md
                    bg-slate-900
                    flex items-center justify-center
                    hover:bg-slate-800
                    transition-colors
                  "
                    >
                      <Icon className="h-4 w-4" />
                    </a>
                  ),
                )}
              </div>
            </div>

            {/* BUYERS */}
            <div>
              <h4 className="text-white font-medium text-sm mb-4">
                For Buyers
              </h4>
              <ul className="space-y-2 text-sm">
                {[
                  "Browse products",
                  "Find suppliers",
                  "Post buying request",
                ].map((item) => (
                  <li key={item}>
                    <a href="#" className="hover:text-white">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* SUPPLIERS */}
            <div>
              <h4 className="text-white font-medium text-sm mb-4">
                For Sellers
              </h4>
              <ul className="space-y-2 text-sm">
                {[
                  "Start selling",
                  "Membership plans",
                  "Display New Products",
                  "Partner with us",
                  "Become a verified supplier",
                  "Success stories",
                ].map((item) => (
                  <li key={item}>
                    <a href="#" className="hover:text-white">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* PAYMENTS */}
            <div>
              <h4 className="text-white font-medium text-sm mb-4">Payments</h4>
              <ul className="space-y-2 text-sm">
                {[
                  "Safe and easy payments",
                  "Buyer protection",
                  "Ship with DoExim",
                ].map((item) => (
                  <li key={item}>
                    <a href="#" className="hover:text-white">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* SERVICES */}
            <div>
              <h4 className="text-white font-medium text-sm mb-4">Services</h4>
              <ul className="space-y-2 text-sm">
                {[
                  "Accounting services",
                  "domain handling",
                  "Subscription plans",
                  "Financial & insurance services",
                  "Advertise with us",
                  "Export CRM",
                  "Shipment tracking",
                  "Currency convertor",
                  "Warehouse & logistics",
                  "Port Handling",
                ].map((item) => (
                  <li key={item}>
                    <a href="#" className="hover:text-white">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            {/* HELP */}
            <div>
              <h4 className="text-white font-medium text-sm mb-4">
                Help & company
              </h4>
              <ul className="space-y-2 text-sm">
                {[
                  { name: "About us", href: "/welcome/about" },
                  { name: "Careers", href: "/welcome/careers" },
                  { name: "Help center", href: "/help" },
                  { name: "Feedback", href: "/help/feedback" },
                  { name: "Complaint", href: "/welcome/complaint" },
                  { name: "Contact us", href: "/welcome/contact" },
                ].map((item) => (
                  <li key={item.name}>
                    <Link href={item.href} className="hover:text-white">
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* CONTACT */}
            <div>
              <h4 className="text-white font-medium text-sm mb-4">Contact</h4>
              <ul className="space-y-3 text-sm">
                <li className="flex gap-2 text-slate-400">
                  <MapPin className="h-4 w-4 mt-0.5" />
                  Pune, Maharashtra, India
                </li>
                <li className="flex gap-2">
                  <Phone className="h-4 w-4 text-slate-400" />
                  +91 9823111103
                </li>
                <li className="flex gap-2">
                  <Mail className="h-4 w-4 text-slate-400" />
                  connect@prosira.in
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="border-t border-slate-800">
          <div
            className="
        container mx-auto px-4 sm:px-6 py-6
        flex flex-col md:flex-row
        items-center justify-between
        gap-4
        text-xs text-slate-400
      "
          >
            <p>Â© 2026 DoExim. All rights reserved.</p>

            <div className="flex gap-4">
              <a href="#" className="hover:text-white">
                Privacy
              </a>
              <a href="#" className="hover:text-white">
                Terms
              </a>
              <a href="#" className="hover:text-white">
                Cookies
              </a>
              <a href="#" className="hover:text-white">
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
